<template>
<div class="chapter">
<div class="inner_page">
<p class="chnum" id="ch-1"><span><a id="page_1"></a><a href="#/Contents#ch1">ONE</a></span></p>
<p class="chtitle"><span><a href="#/Contents#ch1">Stocks</a></span></p>
<p class="line"><span><img alt="" height="3" src="images/line.jpg" width="421"/></span></p>
<p class="image"><span><img alt="" height="336" src="images/page1.jpg" width="283"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter01.vue?ef0cc74e